import { CREATE_AUDIT, CREATE_AUDIT_ERR } from '../../actionTypes/auditType'
import { createAuditApi } from 'api/Api';
import axios from "axios";
import { accessToken } from 'api/Token'
export const createAudit = payload => async dispatch => {
    try {
        ////console.log('payload',payload)
        let results = await axios.post(`${createAuditApi}`, payload, await accessToken())
        ////console.log("User Detail", results)
        let data = results && results.data
        dispatch({
            type: CREATE_AUDIT,
            payload: data || {},
        });
    } catch (error) {

        dispatch({
            type: CREATE_AUDIT_ERR,
            payload: error && error.response
        });
    }
}


